/**
 * format:
 * @REL_ATTR: 401258
 * @id: 401258
 * access_level: {@id: 5003, @REL_ATTR: 5003, @COMMON_NAME: "Modify"}
 * func_access: {@id: 6001, @COMMON_NAME: "Administration", @REL_ATTR: "admin"}
 */

export default class PermissionRole {
  constructor(opts = {}) {
    this.id = opts['@id'] || null;

    this.authCode = null;
    if (opts.func_access != null) {
      this.authCode = opts.func_access['@REL_ATTR'];
    }

    this.accessLevel = null;
    if (opts.access_level != null) {
      this.accessLevel = opts.access_level['@COMMON_NAME'];
    }
  }
}

const createPermissionRole = (role, permission) => new PermissionRole({ func_access: { '@REL_ATTR': role }, access_level: { '@COMMON_NAME': permission } });

export const NAMED_ROLES = {
  VIEW_MANAGEMENT: createPermissionRole('accen_ui_management', 'View'),
  VIEW_CSU: createPermissionRole('accen_ui_csu', 'View'),
  VIEW_MENU_KD: createPermissionRole('accen_ui_kd_menu', 'View'),
  VIEW_KD: createPermissionRole('kd', 'View'),
  VIEW_CI: createPermissionRole('ci', 'View'),
  VIEW_TIMEREPORTS: createPermissionRole('accen_ui_timereports', 'View'),
  VIEW_ADMIN: createPermissionRole('accen_ui_admin', 'View'),
  VIEW_SUPPORT: createPermissionRole('accen_ui_support', 'View'),
  MODIFY_APRROVALS: createPermissionRole('accen_ui_approvals', 'Modify'),
  VIEW_REQUEST: createPermissionRole('accen_ui_requests', 'View'),
  VIEW_INCIDENT: createPermissionRole('accen_ui_incidents', 'View'),
  VIEW_PROBLEM: createPermissionRole('accen_ui_problems', 'View'),
  MODIFY_CHANGE_MGR: createPermissionRole('change_mgr', 'Modify'),
  VIEW_WORKFLOW_REFERENCE: createPermissionRole('workflow_reference', 'View'),
  MODIFY_SIGLO: createPermissionRole('accen_ui_provider', 'Modify'),
  VIEW_KEYUSER: createPermissionRole('accen_ui_key_user', 'View'),
};
